/*
 * sidebar-menu
 */
import { cn } from "@emr/react-ui"
import { Divider, ScrollArea } from "@emr/react-ui"
import type { ReactNode } from "react"

interface MenuProps {
	bottomContent?: ReactNode
	children?: ReactNode
	className?: string
}

export function Menu({ bottomContent, children, className }: MenuProps) {
	return (
		<>
			<ScrollArea
				className={cn(["[&>div>div[style]]:block!", className])}
				viewportClassName={"pr-0!"}
				padScrollBar={false}
			>
				<nav className={"size-full"}>
					<ul className={"flex flex-col items-start space-y-1"}>{children}</ul>
				</nav>
			</ScrollArea>
			<Divider />
			{bottomContent}
		</>
	)
}
